import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "./NavbarComp.css";
import LOGO from "../assets/images/LogoV2.svg";

function NavbarComp() {
  return (
    <Navbar className="navbar" bg="grey" variant="dark" style={{position: "fixed", top: "0", zIndex: 1}}>
      <Container>
        <Navbar.Brand
          href="#about"
        >
          <img src={LOGO} width="40"/>
        </Navbar.Brand>
        <Nav className="me-auto">
          <Nav.Link href="#experience">Experience</Nav.Link>
          <Nav.Link href="#projects">Projects</Nav.Link>
          <Nav.Link href="#skills">Skills</Nav.Link>
          <Nav.Link href="#contact">Contact</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default NavbarComp;
